var map = {
	"./american-express-card-logo.svg": "pmm5",
	"./american-express.svg": "de2E",
	"./bank.svg": "GtHg",
	"./chip.svg": "SxHu",
	"./diners-club-card-logo.svg": "Lv3h",
	"./diners-club.svg": "XUth",
	"./discover-card-logo.svg": "wPGh",
	"./discover.svg": "eica",
	"./jcb-card-logo.svg": "SWoi",
	"./jcb.svg": "8f/d",
	"./mastercard-card-logo.svg": "k5h8",
	"./mastercard.svg": "b58K",
	"./paypal.svg": "vbY5",
	"./unionpay-card-logo.svg": "z4tb",
	"./unionpay.svg": "NUmB",
	"./unknown.svg": "d1Nh",
	"./visa-card-logo.svg": "QlMz",
	"./visa.svg": "HfU2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ofQ";